import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { combineLatest, of, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { PersonaService } from './services/persona.service';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription: Subscription | undefined;
  private res: [NavigationEnd, boolean] | undefined;

  constructor(
    private router: Router,
    private personaService: PersonaService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.setupRouterEvents();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setupRouterEvents(): void {
    this.subscription = combineLatest([
      this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)),
      this.authService.isAuthenticated$
    ])
    .pipe(
      switchMap(([event, isAuthenticated]) => {
        this.res = [event, isAuthenticated];
        if (isAuthenticated && event.url !== '/mi-perfil') {
          return this.personaService.persona$;
        }
        return of(null);
      })
    )
    .subscribe(persona => {
      if (persona && this.res != undefined && this.res[1] && this.res[0].url !== '/mi-perfil') {
        this.personaService.validaPerfilCompletado();
      }
    });
  }
}
